module.exports = __webpack_public_path__ + "img/98.2a2a2af3.jpg";